module.exports = __webpack_public_path__ + "static/media/blue-marlin.2def86f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/blue-marlin.png
// module id = 301
// module chunks = 0